define("shared/components/shared/profile-categorization/rewards-steps/report/not-available", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <h2 class="tSC--card__title u--text--center u--m__0">
    {{@socialProfile.displayNickname}}
  </h2>
  
  <Shared::ProfileCategorization::SelectedTypes
    @businessModel={{@socialProfile.businessModel}}
    @category={{@socialProfile.category}}
    @handleResetSelection={{fn @clearSelectedCategory "summary"}}
    @industry={{@socialProfile.industry}}
    @prefix={{@prefix}}
  />
  
  <div class="tSC--result" {{on "click" (fn @exitCategorization false)}}>
    {{#unless @isModalFlow}}
      <div class="tSC--result__header">
        <span>
          {{t "profile_categorization.reports.not_available.graphic_text"}}
        </span>
        {{svg-jar "arrow-right" class="o--icon u--float--right"}}
      </div>
    {{/unless}}
    {{! TODO: Image needs to be updated }}
    <img class="o--media" src="/assets/images/img--selfCat--noReport.png" />
  </div>
  
  <Shared::Ui::Button
    @additional="block"
    @onClick={{fn @exitCategorization false}}
    @size="regular"
    class="qa--categorize_reports_exit"
  >
    {{#if @isModalFlow}}
      {{t "shared_words.done"}}
    {{else}}
      {{t "authorization.sign_up_success.finish_setup"}}
    {{/if}}
  </Shared::Ui::Button>
  */
  {
    "id": "vsAxqwVx",
    "block": "[[[10,\"h2\"],[14,0,\"tSC--card__title u--text--center u--m__0\"],[12],[1,\"\\n  \"],[1,[30,1,[\"displayNickname\"]]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,0],null,[[\"@businessModel\",\"@category\",\"@handleResetSelection\",\"@industry\",\"@prefix\"],[[30,1,[\"businessModel\"]],[30,1,[\"category\"]],[28,[37,1],[[30,2],\"summary\"],null],[30,1,[\"industry\"]],[30,3]]],null],[1,\"\\n\\n\"],[11,0],[24,0,\"tSC--result\"],[4,[38,2],[\"click\",[28,[37,1],[[30,4],false],null]],null],[12],[1,\"\\n\"],[41,[51,[30,5]],[[[1,\"    \"],[10,0],[14,0,\"tSC--result__header\"],[12],[1,\"\\n      \"],[10,1],[12],[1,\"\\n        \"],[1,[28,[35,4],[\"profile_categorization.reports.not_available.graphic_text\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[1,[28,[35,5],[\"arrow-right\"],[[\"class\"],[\"o--icon u--float--right\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,\"img\"],[14,0,\"o--media\"],[14,\"src\",\"/assets/images/img--selfCat--noReport.png\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[8,[39,6],[[24,0,\"qa--categorize_reports_exit\"]],[[\"@additional\",\"@onClick\",\"@size\"],[\"block\",[28,[37,1],[[30,4],false],null],\"regular\"]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,5],[[[1,\"    \"],[1,[28,[35,4],[\"shared_words.done\"],null]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,4],[\"authorization.sign_up_success.finish_setup\"],null]],[1,\"\\n\"]],[]]]],[]]]]]],[\"@socialProfile\",\"@clearSelectedCategory\",\"@prefix\",\"@exitCategorization\",\"@isModalFlow\"],false,[\"shared/profile-categorization/selected-types\",\"fn\",\"on\",\"unless\",\"t\",\"svg-jar\",\"shared/ui/button\",\"if\"]]",
    "moduleName": "shared/components/shared/profile-categorization/rewards-steps/report/not-available.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});